import { type ChainAvailabilityItem } from '@/models/appointment-chain-availability.ts';
import { type AppointmentChainConfig } from '@/models/appointment-chain-config.ts';

import { dayjs } from '@/utils/dayjsSetup.js';

/** Resolve the chain's display name for the active language, tolerating regional codes like `de-DE`/`de-AT`. */
export const resolveChainName = (config: AppointmentChainConfig, language: string): string =>
    config.name[language.startsWith('de') ? 'de' : 'en'];

export const dayKey = (isoDate: string): string => dayjs(isoDate).format('YYYY-MM-DD');

/** Appointment count is distinct calendar days, so steps sharing a day are counted once. */
export const countDistinctDays = (items: ChainAvailabilityItem[]): number =>
    new Set(items.map((item) => dayKey(item.start_date))).size;
